export const DEFAULT_ACTION_PREFIX = 'KARNOTT_PLOTS';
export const DEFAULT_SERVICE_NAME = 'plots';
export const DEFAULT_ACCESSOR_CHAIN = [DEFAULT_SERVICE_NAME];

export const PLOTS_TYPES = {
  farmhouse: 'farmhouse',
  field: 'field',
};
